<template>

  <div id="app">

    <TopNavBar />

    <template v-if="$route.name">

      <router-view />

      <router-link 
        v-if="$route.name !== 'contact'" 
        to="/contact" 
        class="floating-contact-icon" 
        title="Contact Us" >
        <font-awesome-icon :icon="['fas', 'envelope']" size="lg" />
      </router-link>      

    </template>
    
  </div>
</template>

<script>

import TopNavBar from '@/views/TopNavBar'

export default {
  components: {
    TopNavBar
  },
}
</script>

<style lang="scss">

body {
  margin: 0;
  background: #FBFBFF;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* Scope centering only where it matters */
.header-section,
.centered-content {
  text-align: center;
}

.floating-contact-icon {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #087F8C;
  color: white;
  padding: 12px;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  transition: background-color 0.3s ease;
  text-decoration: none;
}

.floating-contact-icon:hover {
  background-color: #065e69;
}

@media (max-width: 500px) {
  .floating-contact-icon {
    bottom: 10px;
    right: 10px;
    padding: 10px;
  }
}


</style>
